import React from "react";

interface Props {
  pdt?: number;
  pdb?: number;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  background?: string;
}

export default function Layout({
  children,
  pdt,
  pdb,
  background,
  style,
}: Props) {
  return (
    <section
      style={{
        width: "100%",
        padding: `${pdt === undefined ? 30 : pdt}px var(--layout-pdx) ${
          pdb === undefined ? 50 : pdb
        }px`,
        background,
        ...style,
      }}
    >
      {children}
    </section>
  );
}
